import GroupChatContainer from "../../../../Component/Application/Chat/VideoChat/VideoChat"

const GroupChat = () => {
  return (
    <div className='page-body'>
      <GroupChatContainer />
    </div>
  )
}

export default GroupChat